module.exports = __webpack_public_path__ + "static/media/gen_lig.d9430724.png";